import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputDefault from '../../../../components/InputDefault/index.js';
import SelectDefault from '../../../../components/SelectDefault/index.js';
import LoadingCard from './LoadingCard';
import { CardContainer, CardHeader, CardBody, FormGroup } from './CardStyles';
import api from '../../../../services/api.js';
import moment from 'moment';

const ContractCard = ({ studyId, onDataUpdate }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [contractData, setContractData] = useState({
    idDm014: 0,
    nrAnomesUltFatura: '',
    nmUsuario: '',
    dtAlteracao: '',
    inStatus: '',
    dtVigenciaDe: '',
    dtVigenciaAte: '',
    idDm013: 0
  });

  const formatDate = (dateStr) => {
    if (dateStr === '' || dateStr === null) {
      return '';
    }
    return moment(dateStr).format('YYYY-MM-DD');
  };

  useEffect(() => {
    const fetchContractData = async () => {
      try {
        setIsLoading(true);
        const contractResponse = await api.get(`contract?id=${studyId}`);
        const data = contractResponse.data.data[0];
        
        if (contractResponse.status === 200) {
          const updatedData = {
            idDm014: studyId,
            nrAnomesUltFatura: data.NR_ANOMES_ULT_FATURA || '',
            nmUsuario: data.NM_USUARIO,
            dtAlteracao: formatDate(data.DT_ALTERACAO),
            idDm013: data.ID_DM013,
            inStatus: data.IN_STATUS,
            dtVigenciaDe: formatDate(data.DT_VIGENCIA_DE),
            dtVigenciaAte: formatDate(data.DT_VIGENCIA_ATE)
          };
          
          setContractData(updatedData);
          onDataUpdate(updatedData);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error('Erro ao buscar dados do contrato:', error);
      }
    };

    if (studyId) {
      fetchContractData();
    }
  }, [studyId, onDataUpdate]);

  const handleChange = (field, value) => {
    const updatedData = { ...contractData, [field]: value };
    setContractData(updatedData);
    onDataUpdate(updatedData);
  };

  if (isLoading) {
    return <LoadingCard title="Carregando Dados do Contrato..." />;
  }

  return (
    <CardContainer>
      <CardHeader>
        <h5>Dados do Contrato ({contractData.idDm014})</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col xs={12} md={4}>
            <FormGroup>
              <InputDefault
                placeholder="Mês/Ano"
                Width={'100%'}
                Margin={'0'}
                value={contractData.nrAnomesUltFatura}
                onChange={(e) => handleChange('nrAnomesUltFatura', e.target.value)}
                Text={'Mês/Ano Última Fatura'}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <FormGroup>
              <InputDefault
                placeholder=""
                Width={'100%'}
                Margin={'0'}
                value={contractData.dtVigenciaDe}
                onChange={(e) => handleChange('dtVigenciaDe', e.target.value)}
                Text={'Vigência de'}
                type={'date'}
              />
            </FormGroup>
          </Col>
          <Col xs={12} md={6}>
            <FormGroup>
              <InputDefault
                placeholder=""
                Width={'100%'}
                Margin={'0'}
                value={contractData.dtVigenciaAte}
                onChange={(e) => handleChange('dtVigenciaAte', e.target.value)}
                Text={'Vigência até'}
                type={'date'}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={8}>
            <FormGroup>
              <SelectDefault
                Width={'100%'}
                Margin={'0'}
                Text={'Situação'}
              value={`${contractData.inStatus}`}
              onChange={(e) => handleChange('inStatus', e.target.value)}>
              <option value="1">ENVIADO</option>
              <option value="2">AGUARDANDO APROVAÇÃO</option>
              <option value="3">APROVADO</option>
              <option value="4">NÃO APROVADO</option>
            </SelectDefault>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </CardContainer>
  );
};

export default ContractCard;
